// src/components/Menu.js
import React from 'react';
import MenuItem from './MenuItem';
import './Menu.css';

// Import your images
import croissantImg from '../images/croissant.jpg';
import sourdoughImg from '../images/sourdough.jpg';
import cupcakeImg from '../images/cupcake.jpg';
import macaronsImg from '../images/macarons.jpg';

const menuData = [
  {
    id: 1,
    name: 'Butter Croissant',
    description: 'Flaky and buttery, a classic French pastry.',
    price: '$3.50',
    image: croissantImg,
  },
  {
    id: 2,
    name: 'Sourdough Loaf',
    description: 'Crusty, tangy, and perfect for any meal.',
    price: '$7.00',
    image: sourdoughImg,
  },
  {
    id: 3,
    name: 'Red Velvet Cupcake',
    description: 'Rich cocoa flavor with a cream cheese frosting.',
    price: '$4.25',
    image: cupcakeImg,
  },
  {
    id: 4,
    name: 'Assorted Macarons',
    description: 'A delicate and colorful almond meringue cookie.',
    price: '$2.50 ea',
    image: macaronsImg,
  },
];

const Menu = () => {
  return (
    <section id="menu" className="menu-section">
      <h2>Our Menu</h2>
      <div className="menu-grid">
        {menuData.map((item) => (
          <MenuItem
            key={item.id}
            name={item.name}
            description={item.description}
            price={item.price}
            image={item.image}
          />
        ))}
      </div>
    </section>
  );
};

export default Menu;